import { type CookieName, getFromCookie, setInCookie } from "../cookies/cookie";
import { getFromLocalStorage, setInLocalStorage } from "./localStorage";

export function setInLocalStorageOrCookie(name: CookieName, value: any, nDays: number) {
	if (modernizrNotLoaded() || Modernizr.localstorage) {
		setInLocalStorage(name, value, nDays);
	} else {
		setInCookie(name, value, nDays);
	}
}

export function getFromLocalStorageOrCookie(name: CookieName): string | null {
	if (modernizrNotLoaded() || Modernizr.localstorage) {
		return getFromLocalStorage(name);
	}
	return getFromCookie(name);
}

export function getFromLocalStorageOrCookieAsNumber(name: CookieName): number | null {
	const valueAsString = getFromLocalStorageOrCookie(name);
	if (valueAsString === null) return null; //don't use !valueAsString, since a "0"-value is seen as false
	const cookieValueAsNumber = Number.parseInt(valueAsString);
	if (Number.isNaN(cookieValueAsNumber) || isNaN(cookieValueAsNumber)) return null;

	return cookieValueAsNumber;
}

function modernizrNotLoaded(): boolean {
	return typeof Modernizr === "undefined";
}
